import { useEffect, useRef, useState } from "react";
import "./MultiDropdown.css";
import { ChevronDown } from "react-bootstrap-icons";

const MultiDropdown = ({ options, selectedValues, onChange, placeholder, resetKey }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    const toggleOption = (id) => {
        const numericId = Number(id); // ✅ force number

        if (selectedValues.includes(id)) {
            onChange(selectedValues.filter(v => v !== numericId));
        } else {
            onChange([...selectedValues, numericId]);
        }
    };

    const displayText =
        selectedValues.length === 0
            ? placeholder
            : `${selectedValues.length} Subtype${selectedValues.length > 1 ? "s" : ""} selected`;

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        setOpen(false);
    }, [resetKey]);

    return (
        <div className="multi-dd" ref={ref}>
            {/* Toggle */}
            <div
                className={`multi-dd-toggle ${selectedValues.length ? "filled" : ""}`}
                onClick={() => setOpen(!open)}
            >
                <span>{displayText}</span>
                <span className="arrow">
                    <ChevronDown />
                </span>
            </div>

            {/* Menu */}
            {open && (
                <div className="multi-dd-menu">
                    {options.map(opt => {
                        // const checked = selectedValues.includes(opt.id);
                        const checked = selectedValues.includes(Number(opt.id));

                        return (
                            <div
                                key={opt.id}
                                className={`multi-dd-item ${checked ? "selected" : ""}`}
                                onClick={() => toggleOption(opt.id)}
                            >
                                <input
                                    type="checkbox"
                                    checked={checked}
                                    readOnly
                                />
                                <span className="label">{opt.label}</span>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default MultiDropdown;
